/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/media-has-caption */
import React, { useState } from 'react'

interface VideoPlayerProps extends React.VideoHTMLAttributes<HTMLVideoElement> {
  fullImage?: boolean
  videoSrc: string
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({ fullImage = false, videoSrc, ...props }) => {
  const containerStyle = {
    position: 'relative',
    display: 'inline-block',
  } as React.CSSProperties

  const videoStyle = {
    width: '100%',
    display: 'block',
  } as React.CSSProperties

  const playButtonContainerStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
  } as React.CSSProperties

  const playButtonStyle = {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    border: 'none',
    borderRadius: '50%',
    width: '60px',
    height: '60px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    outline: 'none',
  } as React.CSSProperties

  const playButtonIconStyle = {
    fill: '#fff',
  } as React.CSSProperties

  const [showPlayButton, setShowPlayButton] = useState(true)

  return (
    <div style={containerStyle}>
      <video style={videoStyle} controls {...props}>
        <source src={videoSrc} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      {!fullImage && (
        <div style={playButtonContainerStyle}>
          {showPlayButton ? (
            <button
              type="button"
              style={playButtonStyle}
              onClick={e => {
                e.stopPropagation()
                setShowPlayButton(false)
                document.querySelector('video')?.play()
              }}
            >
              <svg width="50" height="50" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5v14l11-7L8 5z" style={playButtonIconStyle} />
              </svg>
            </button>
          ) : (
            <button
              type="button"
              style={playButtonStyle}
              onClick={e => {
                e.stopPropagation()
                setShowPlayButton(true)
                document.querySelector('video')?.pause()
              }}
            >
              <svg width="50" height="50" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 6h12v12H6V6z" style={playButtonIconStyle} />
              </svg>
            </button>
          )}
        </div>
      )}
    </div>
  )
}

export default VideoPlayer
